import { ComponentType, FC, ReactNode } from 'react';
import cx from 'classnames';
import { css } from './FloatingFooter.css';

interface IProps {
  children: ReactNode;
  className?: string;
}

export const withFloatingFooter = <T extends {}>(
  Component: ComponentType<T>
): FC<T> => {
  const WithFloatingFooter: FC<T> = (props) => (
    <div className={cx(css.wrapper)}>
      <Component {...(props as T)} />
    </div>
  );

  return WithFloatingFooter;
};

export const FloatingFooter = ({ children, className }: IProps) => {
  return (
    <>
      <div className={css.spacer} />
      <div className={css.footer}>
        <div className={css.contentWrapper}>
          <div className={cx(css.content, className)}>{children}</div>
        </div>
      </div>
    </>
  );
};
